import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import SearchIcon from './SearchIcon';

interface ContainerProps {
  $disabled: boolean;
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
`;

const Container = styled.div<ContainerProps>`
  position: absolute;
  top: 0;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ $disabled }) =>
    $disabled
      ? css`
          cursor: not-allowed;
          opacity: 0.5;
          pointer-events: none;
        `
      : css`
          cursor: pointer;

          &:hover::before {
            content: '';
            position: absolute;
            width: 36px;
            height: 36px;
            background-color: rgba(227, 22, 144, 0.15);
            border-radius: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          &:active::before {
            background-color: rgba(227, 22, 144, 0.5);
            animation: ${fadeIn} 0.3s ease;
          }
        `}
`;

interface SearchIconButtonProps {
  onClick: () => void;
  disabled: boolean;
}

const SearchIconButton: React.FC<SearchIconButtonProps> = ({
  onClick,
  disabled
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <Container onClick={handleClick} $disabled={disabled}>
      <SearchIcon />
    </Container>
  );
};

export default SearchIconButton;
